import React from "react";

import { OverflowTooltip } from "components";

import styles from "../matchReport.module.scss";

const mainColumn = ({ name, title, disableSortBy = false }) => ({
	Header: title,
	accessor: name,
	disableSortBy,
	classNameHeader: `${styles.tableHeader}`,
	Cell: ({ value }) => (
		<OverflowTooltip onlyOnLaptop title={value}>
			{value}
		</OverflowTooltip>
	),
});

export default mainColumn;
